exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.in[data-v-758d2aad] {\n    display: block;\n}\n.products-table[data-v-758d2aad] {\n    font-size: 13px;\n}\n", ""]);

// exports
